export interface CookieData {
  name: string;
  value: string;
  expireDate?: Date;
}

export const setCookie = (cookie: CookieData) => {
  document.cookie =
    cookie.name +
    "=" +
    cookie.value +
    "; Path=/;" +
    (cookie.expireDate ? " Expires=" + cookie.expireDate.toUTCString() : "");
};

export const getCookie = (name: string): CookieData | null => {
  const cookieNamePattern = new RegExp(name + "=([^;]+)");
  const cookieValue = cookieNamePattern.exec(document.cookie);
  return cookieValue && cookieValue[1]
    ? {
        name,
        value: cookieValue[1],
      }
    : null;
};

export const deleteCookie = (name: string) => {
  document.cookie = name + "=; Path=/; Expires=Thu, 01 Jan 1970 00:00:01 GMT;";
};
